import { ROUTES } from "@features/rh/config/constants";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(dashboard)/mes-conges/")({
  loader: () => {
    throw redirect({ to: ROUTES.RH.CONGES.ME });
  },
});
